import { actionTypes } from "actions/brik/actionTypes";

const initState = {
  data: {},
  gettingListBrik: false,
  loading: false,
  listData: {},
  listNameSub: {},
  createSub: {},
  orderSub: {},
  deleteSub: {},
  updateSectionState: {},
  brikGoLive: {},
  createContent: {},
  updateContent: {},
  deleteContent: null,
  duplicateBrik: null,
  brikDetail: null,
  filterBrik: null,
  listShare: null,
  duplicateSection: null,
  section: null,
  listSection: null
};

export default (state: any = initState, action: any) => {
  const { type, payload, typeBrik } = action;
  switch (type) {
    case actionTypes.CLEAR_LIST_BRIK:
      return {
        ...state,
        listData: {},
      };

    case actionTypes.GET_LIST_BRIK:
      return {
        ...state,
        gettingListBrik: true,
      };
    case actionTypes.GET_LIST_BRIK_SUCCESS:
      return {
        ...state,
        listData: payload,
        gettingListBrik: false,
        filterBrik: typeBrik,
      };
    case actionTypes.GET_LIST_BRIK_FAIL:
      return {
        ...state,
        gettingListBrik: false,
        loading: false,
      };

    case actionTypes.CREATE_BRIK:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.CREATE_BRIK_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case actionTypes.CREATE_DAY_FAIL:
    case actionTypes.CREATE_LENGTH_FAIL:
    case actionTypes.UPDATE_BRIK_FAIL:
    case actionTypes.CREATE_SECTION_FAIL:
    case actionTypes.DELETE_ALL_SUB_SECTION:
    case actionTypes.CREATE_BRIK_FAIL:
    case actionTypes.ORDER_LENGTH:
      return {
        ...state,
        loading: false,
      };

    case actionTypes.DELETE_ALL_SUB_SECTION_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };

    case actionTypes.DELETE_ALL_SUB_SECTION_FAIL:
      return {
        ...state,
        loading: false,
      };

    case actionTypes.ORDER_LENGTH_FAIL:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.ORDER_LENGTH_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case actionTypes.UPDATE_BRIK:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.UPDATE_BRIK_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };

    case actionTypes.CREATE_SECTION:
      return {
        ...state,
        section: null,
        loading: true,
      };
    case actionTypes.CREATE_SECTION_SUCCESS:
      return {
        ...state,
        section: payload,
        loading: false,
      };

    case actionTypes.CREATE_LENGTH:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.CREATE_LENGTH_SUCCESS:
      return {
        ...state,
        length: payload,
        loading: false,
      };

    case actionTypes.CREATE_DAY:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.CREATE_DAY_SUCCESS:
      return {
        ...state,
        days: payload,
        loading: false,
      };
    case actionTypes.CREATE_SUB_SECTION:
      return {
        ...state,
        createSub: {},
        loadingCreateSub: true,
      };
    case actionTypes.CREATE_SUB_SECTION_SUCCESS:
      return {
        ...state,
        createSub: payload,
        loadingCreateSub: false,
      };
    case actionTypes.CREATE_SUB_SECTION_FAIL:
      return {
        ...state,
        loadingCreateSub: false,
      };
    case actionTypes.ORDER_SUB_SECTION_SUCCESS:
      return {
        ...state,
        orderSub: payload,
        loading: false,
      };
    case actionTypes.DELETE_SUB_SECTION:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.DELETE_SUB_SECTION_SUCCESS:
      return {
        ...state,
        deleteSub: payload,
        loading: false,
      };
    case actionTypes.GET_BRIK_DETAIL:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_BRIK_DETAIL_SUCCESS:
      return {
        ...state,
        brikDetail: payload,
        loading: false,
      };
    case actionTypes.GET_BRIK_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.CLEAR_DETAIL_BRIK:
      return {
        ...state,
        brikDetail: null,
      };
    case actionTypes.GET_LIST_SECTION:
      return {
        ...state,
        listSection: null,
        loading: false,
      };
    case actionTypes.GET_LIST_SECTION_SUCCESS:
      return {
        ...state,
        listSection: payload,
        loading: false,
      };
    case actionTypes.GET_LIST_SECTION_FAIL:
      return {
        ...state,
        listSection: null,
        loading: false,
      };

    case actionTypes.GET_NAME_SUB_SECTION_SUCCESS:
      return {
        ...state,
        listNameSub: payload,
        loading: false,
      };
    case actionTypes.UPDATE_SECTION_SUCCESS:
      return {
        ...state,
        updateSectionState: payload,
        loading: false,
      };
    case actionTypes.ORDER_SECTION_SUCCESS:
      return {
        ...state,
        orderSection: payload,
        loading: false,
      };
    case actionTypes.CREATE_CONTENT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.CREATE_CONTENT_SUCCESS:
      return {
        ...state,
        createContent: payload,
        loading: false,
      };
    case actionTypes.CREATE_CONTENT_FAIL:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.UPDATE_CONTENT_SUCCESS:
      return {
        ...state,
        updateContent: payload,
        loading: false,
      };
    case actionTypes.ORDER_CONTENT_SUCCESS:
      return {
        ...state,
        orderContent: payload,
        loading: false,
      };
    case actionTypes.DELETE_SECTION_SUCCESS:
      return {
        ...state,
        deleteSection: payload,
        loading: false,
      };
    case actionTypes.DELETE_CONTENT_SUCCESS:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.DELETE_CONTENT_SUCCESS:
      return {
        ...state,
        deleteContent: payload,
        loading: false,
      };
    case actionTypes.DUPLICATE_BRIK_SUCCESS:
      return {
        ...state,
        duplicateBrik: payload,
        loading: false,
      };
    case actionTypes.DUPLICATE_SECTION:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.DUPLICATE_SECTION_SUCCESS:
      // Add the duplicated section to the appropriate section list in listSection
      let updatedListSection = state.listSection;
      if (state.listSection && payload) {
        console.log('DUPLICATE_SECTION_SUCCESS - payload:', payload);
        
        updatedListSection = { ...state.listSection };
        
        // Ensure sub_section exists as an array for all section types
        const enrichedPayload = {
          ...payload,
          sub_section: payload.sub_section || []
        };
        
        // Determine which section list to update based on the numeric type_section
        // TYPE_SECTION: CONTENT = 0, MEAL = 1, WORKOUT = 2
        if (enrichedPayload.type_section === 0) {
          console.log('Adding to section_content (type_section: 0)');
          updatedListSection.section_content = [
            ...(updatedListSection.section_content || []),
            enrichedPayload
          ];
        } else if (enrichedPayload.type_section === 1) {
          console.log('Adding to section_meal (type_section: 1)');
          updatedListSection.section_meal = [
            ...(updatedListSection.section_meal || []),
            enrichedPayload
          ];
        } else if (enrichedPayload.type_section === 2) {
          console.log('Adding to section_workout (type_section: 2)');
          updatedListSection.section_workout = [
            ...(updatedListSection.section_workout || []),
            enrichedPayload
          ];
        } else {
          console.warn('Unknown section type_section:', enrichedPayload.type_section, 'payload:', enrichedPayload);
          // Don't add to any array if type is unknown to prevent duplication
        }
        
        console.log('DUPLICATE_SECTION_SUCCESS - updated listSection:', updatedListSection);
      }
      
      return {
        ...state,
        duplicateSection: payload,
        listSection: updatedListSection,
        loading: false,
      };
    case actionTypes.DUPLICATE_SECTION_FAIL:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.SHARE_BRIK_SUCCESS:
      return {
        ...state,
        shareBrik: payload,
        loading: false,
      };
    case actionTypes.GET_LIST_SHARE_SUCCESS:
      return {
        ...state,
        listShare: payload,
        loading: false,
      };
    case actionTypes.DELETE_BRIK_SUCCESS:
      return {
        ...state,
        deleteBrik: payload,
        loading: false,
      };
    case actionTypes.DELETE_LENGTH_SUCCESS:
      return {
        ...state,
        deleteLength: payload,
        loading: false,
      };
    case actionTypes.DELETE_DAY_SUCCESS:
      return {
        ...state,
        deleteDay: payload,
        loading: false,
      };

    case actionTypes.CHANGE_BRIK_STATUS_SUCCESS:
      return {
        ...state,
        brikGoLive: payload,
      };

    case actionTypes.DUPLICATE_LENGTH_SUCCESS:
      return {
        ...state,
        duplicateLength: payload,
        loading: false,
      };
    case actionTypes.DUPLICATE_DAY_SUCCESS:
      return {
        ...state,
        duplicateDay: payload,
        loading: false,
      };

    case actionTypes.LIST_SHARED_DATA_SUCCESS:
      return {
        ...state,
        listSharedData: payload,
        loading: false,
      };
    case actionTypes.UNSHARE_BRIK:
      return {
        ...state,
        unshare: payload,
        loading: false,
      };

    default:
      return state;
  }
};
